export const INFO_ALERT = 'info';

export const ERROR_ALERT = 'error';

export const SUCCESS_ALERT = 'success';

export const WARNING_ALERT = 'warning';